<template>
	<div>
		<v-dialog v-model="dialog_share_options" no-click-animation scrollable persistent transition="slide-y-transition">
	      <v-card>
	        <v-card-text nopadding>
	        	
	        	<v-list nopadding>
		        	<v-list-tile id="shareExcelBtn">
			            <v-list-tile-title>Share Excel</v-list-tile-title>
		        	</v-list-tile>
		        	<v-divider></v-divider>
		        	<v-list-tile @click="sharePdf('pdf', true)">
			            <v-list-tile-title>Share PDF</v-list-tile-title>
		        	</v-list-tile>
		        </v-list>

	        </v-card-text>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['sharePdf'],
		data(){
			return{
				dialog_share_options: false
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_share_options = true;
			},
			closeDialogWeb: function () {
				this.dialog_share_options = false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/newreports/dialogs/dialog_share_options.vue